<div class="modal fade show custom_popup" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header justify-content-between">
        <h5 class="modal-title">Contract Details</h5>
        <div>
          <button type="button" class="close" data-dismiss="modal" (click)="closeContractDialog()">
            <span>&times;</span>
          </button>
        </div>
      </div>

      <div class="modal-body padding-model form-editing">
        <div class="gap-1 mt-2">
          <form [formGroup]="contractForm">
            <div class="details-etr row">
              <div class="details-etr-left">
                <div class="width-235 mb-2 z-index-99">
                  <ng-select
                    class="custom"
                    id="debtor"
                    [style.flex]="1"
                    [items]="debtorList"
                    bindLabel="combinedLabel"
                    bindValue="id"
                    placeholder="Select Debtor..."
                    formControlName="debtor"
                    [virtualScroll]="true"
                    [clearable]="true"
                    [searchFn]="customSearch"
                  >
                    <ng-template ng-label-tmp let-item="item">
                      {{ item.name }}
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                      <span [title]="item.name" tooltip="item.name">{{ item.id }} - {{ item.name }}</span>
                    </ng-template>
                  </ng-select>
                </div>
                <div class="width-235 mb-1">
                  <div class="d-flex align-items-center">
                    <label for="company" class="form-title me-2 mt-1" style="font-weight: bold">Contract</label>
                    <input formControlName="contractFile" type="file" id="company" name="myfile" />
                  </div>
                </div>
              </div>
              <div class="details-etr-right">
                <textarea
                  id="details"
                  type="text"
                  cols="50"
                  rows="4"
                  formControlName="description"
                  class="form-control ft-width"
                  placeholder="Enter a general and simple description of the project or contract ..."
                ></textarea>
              </div>
            </div>

            <div class="row mt-2">
              <div class="col-12 col-md-12 col-lg-6">
                <div class="row justify-content-between px-1">
                  <div class="width-170 mb-1">
                    <div class="d-flex align-items-center">
                      <label for="start" class="form-title me-2 mt-1" style="font-weight: bold">Start</label>
                      <div class="input-group">
                        <app-date-picker id="start" formControlName="startDate" [maxDate]="maxDate" />
                        <app-form-error-component [control]="contractForm.controls['startDate']" />
                      </div>
                    </div>
                  </div>
                  <div class="width-170 mb-1">
                    <div class="d-flex align-items-center">
                      <label for="end" class="form-title me-2 mt-1" style="font-weight: bold">End</label>
                      <div class="input-group">
                        <app-date-picker id="end" formControlName="endDate" [maxDate]="maxDate" />
                        <app-form-error-component [control]="contractForm.controls['endDate']" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row justify-content-between px-1 responsive-ref">
                  <div class="width-120">
                    <input
                      class="form-control text-right ft-width"
                      type="text"
                      placeholder="Unique Reference"
                      formControlName="reference"
                    />
                  </div>
                  <div class="width-262">
                    <input
                      class="form-control text-right ft-width"
                      type="text"
                      placeholder="Project Name, e.g."
                      formControlName="projectName"
                    />
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-12 col-lg-6">
                <div class="row mt-4 align-items-center rs-facevalue">
                  <div class="width-161 z-index-99">
                    <div class="d-flex align-items-center">
                      <label for="totalValue" class="form-title me-2 mt-1 text-nowrap" style="font-weight: bold"
                        >Total Value</label
                      >

                      <ng-select
                        class="custom ccy-dd"
                        id="totalValue"
                        [style.flex]="1"
                        [items]="currencyList"
                        bindLabel="name"
                        bindValue="id"
                        placeholder="Ccy"
                        [virtualScroll]="true"
                        [clearable]="true"
                        formControlName="ccy"
                      >
                        <ng-template ng-label-tmp let-item="item">
                          {{ item.name }}
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item">
                          <span [title]="item.name" tooltip="item.name">{{ item.name }}</span>
                        </ng-template>
                      </ng-select>

                      <input
                        class="form-control text-right ft-width inputNumberTextRight ms-1"
                        type="text"
                        placeholder="Total"
                        [appOnlyNumber]="true"
                        formControlName="total"
                        style="width: 120px"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="row mt-2 responsive-instructions">
            <div class="col-6">
              <div class="row">
                <div class="width-170 mb-1 container-grid">
                  <app-grid-container
                    [gridOptions]="gridOptions"
                    [gridRowData]="rowDataSupplierInvoices || []"
                    [gridColDefs]="colDefsSupplierInvoices"
                    [gridDefaultColDef]="defaultColDef"
                    [hasPagination]="false"
                    (gridReady)="onGridReadySupplierInvoices($event)"
                    (cellEditingStopped)="handleEditingStop($event, 'supplier')"
                  />
                </div>
              </div>
              <div class="row">
                <div>
                  <b style="font-size: 13px">Instructions: </b>
                  <span style="font-size: 12px"
                    >if you know the approximate date and value of each invoice enter a full list above.</span
                  >
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="row">
                <div class="width-170 mb-1 container-grid">
                  <app-grid-container
                    [gridRowData]="rowDataInvoiceDescription || []"
                    [gridColDefs]="colDefsInvoiceDescription"
                    [gridDefaultColDef]="defaultColDef"
                    [hasPagination]="false"
                    (gridReady)="onGridReadyInvoiceDescription($event)"
                    (cellEditingStopped)="handleEditingStop($event, 'description')"
                  />
                </div>
              </div>
              <div class="row">
                <div>
                  <b style="font-size: 13px">Instructions: </b>
                  <span style="font-size: 12px"
                    >if you know the approximate date and value of each invoice enter a full list above.</span
                  >
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-6">
              <div class="row">
                <div class="d-flex justify-content-between">
                  <button
                    (click)="addBEtr()"
                    type="button"
                    style="background-color: #c5cacb"
                    class="btn btn-light custom-tab-button width-85"
                  >
                    Add b-ETR
                  </button>
                  <button
                    (click)="handleProcess()"
                    type="button"
                    style="background-color: #c5cacb"
                    class="btn btn-light custom-tab-button width-85"
                  >
                    Process
                  </button>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="row">
                <div class="d-flex justify-content-between">
                  <button
                    type="button"
                    class="btn btn-light custom-tab-button width-85"
                    (click)="closeContractDialog()"
                  >
                    Cancel
                  </button>
                  <button
                    (click)="addDEtr()"
                    type="button"
                    style="background-color: #c5cacb"
                    class="btn btn-light custom-tab-button width-85"
                  >
                    Add d-ETR
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <input #fileInput id="upload_file" type="file" (change)="fileChange($event)" name="upload_file" />
      </div>
    </div>
  </div>
</div>
